export default __webpack_public_path__ + "static/media/astropay-logo.2afeb3ac.svg";